import { ICarePlanIcd10CodesStore } from './types';

const initStore: ICarePlanIcd10CodesStore = {
  items: [],
};

export default initStore;
